var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{class:['deadline-timespan', _vm.timeSpanClass(new Date(_vm.dateTime * 1000))]},[_vm._v(" "+_vm._s(_vm.calc(new Date(_vm.dateTime * 1000)))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }